import { downloadCSVFile, getPathAPI } from "@/helpers";
import { AxiosRequestConfig } from "axios";
import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

export type IPersonalLiabilityExportPayload = {
  startDate?: string;
  endDate?: string;
  status?: string[];
  path: string;
};

class PersonalLiabilityExportService extends BaseCollectionService {
  constructor() {
    super("export-personal-liability-policies");
  }
  public async exportPersonalLiabilityPolicies(
    payload: IPersonalLiabilityExportPayload
  ): Promise<ResponseWrapper> {
    const axiosConfig: AxiosRequestConfig = {
      baseURL: getPathAPI(),
      url: payload.path,
      method: "GET",
      responseType: "blob",
      params: {
        startDate: payload.startDate,
        endDate: payload.endDate,
        status: payload.status
      }
    };

    let response;
    try {
      response = await this.request(axiosConfig, { useToken: "access" });
    } catch (error) {
      const blob = error?.raw?.response?.data;
      if (blob instanceof Blob) {
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          throw new Error(
            json.response?.message ||
              json.message ||
              json.error ||
              "Failed to export Personal Liability Applications"
          );
        } catch (parseError) {
          if (parseError instanceof SyntaxError) {
            throw new Error(
              error.message ||
                "Failed to export Personal Liability Applications"
            );
          }
          throw parseError;
        }
      }
      throw error;
    }

    downloadCSVFile(response.data, "PersonalLiabilityApplicationsExport.csv");

    return response;
  }
}

export default new PersonalLiabilityExportService();
